import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/login/social.svg")